// extracted by mini-css-extract-plugin
export default {"productDetails":"Read_productDetails__6fW+r","mainImage":"Read_mainImage__tMEHR","imageGallery":"Read_imageGallery__NrH0E"};